import Icon from 'veui/components/Icon'
import { IconHeart } from 'dls-icons-vue'

Icon.register('heart', IconHeart)
